import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import ListerProgress from "@/pages/batch/ListerProgress";

// Shown once per week to the lister who hits their weekly goal: Pac-Man clears the track and eats the logo.
export default function GoalCelebration({ week, count, goal }) {
  const key = `snaplist.goalHit.${week}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) !== "1");
  if (!open) return null;
  const close = () => { localStorage.setItem(key, "1"); setOpen(false); };
  return (
    <Dialog open onOpenChange={(o) => !o && close()}>
      <DialogContent className="w-[calc(100%-1.5rem)] max-w-sm rounded-2xl bg-slate-950 text-white" data-testid="goal-celebration">
        <DialogTitle className="font-['Space_Grotesk'] text-xl">Weekly goal smashed!</DialogTitle>
        <DialogDescription className="text-sm text-slate-300" data-testid="goal-celebration-text">
          You listed <b className="text-white">{count}</b> items this week. Your goal was {goal}.
        </DialogDescription>
        <div className="rounded-xl bg-slate-800 px-3 py-2 [&_.lp-track]:bg-slate-950 [&_.text-slate-500]:text-slate-400 [&_.text-slate-800]:text-white">
          <ListerProgress listed={goal} total={goal} name="You" testid="goal-celebration-pacman" />
        </div>
        <Button className="rounded-full bg-[#facc15] font-semibold text-slate-900 hover:bg-[#eab308]" onClick={close} data-testid="goal-celebration-dismiss">Keep going!</Button>
      </DialogContent>
    </Dialog>
  );
}
